import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsRoutePath } from '#/modules/search/internships/routing/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/jobs/routing/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/orgs/routing/searchGetOrgsRoutePath';
import { createOrgRoute, postAListingRoute } from '#/routing/routes';

import type { PageFooterData } from './types/PageFooterData';

export const pageFooterDataEs: PageFooterData = {
  idealistDays: {
    title: 'Participa',
    links: [
      {
        type: 'our-vision',
        title: 'Nuestra visión',
        href: '/es/dias/saber-mas',
      },
      {
        type: 'spread-the-word',
        title: 'Pasa la voz',
        href: '/es/dias/pasa-la-voz',
      },
      {
        type: 'plan-ahead',
        title: 'Planifica tu participación',
        href: '/es/days/planea-proximo-dia-idealist',
      },
      {
        type: 'take-a-logo',
        title: 'Usa el logo',
        href: '/es/dias/logos',
      },
      {
        type: 'support-our-work',
        title: 'Apoya nuestro trabajo',
        href: '/es/dona',
      },
    ],
  },
  volunteer: null,
  findAJob: {
    title: 'Encuentra empleo',
    links: [
      {
        type: 'jobs',
        title: 'Empleos',
        href: searchGetJobsRoutePath({
          locale: I18nLocale.ES,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'internships',
        title: 'Pasantías',
        href: searchGetInternshipsRoutePath({ locale: I18nLocale.ES }),
      },
      {
        type: 'organizations',
        title: 'Organizaciones',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.ES }),
      },
      {
        type: 'career-advice',
        title: 'Desarrollo de carrera',
        href: '/es/accion?categories=empleocambiamundo&pq=',
      },
    ],
  },
  postOnIdealist: {
    title: 'Publica',
    links: [
      {
        type: 'post-a-listing',
        title: 'Publica una Oportunidad',
        href: postAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Suma tu Organización',
        href: createOrgRoute.with({}),
      },
      {
        type: 'create-community-group',
        title: 'Suma tu Colectivo Ciudadano',
        href: createOrgRoute.with({}),
      },
      {
        type: 'employer-resources',
        title: 'Herramientas para Reclutadores',
        href: '/es/orgs/encuentra-talento',
      },
      {
        type: 'help-center',
        title: 'Centro de Ayuda',
        href: '/es/ayuda',
      },
    ],
  },
  aboutUs: {
    title: 'Acerca de',
    links: [
      {
        type: 'our-story',
        title: 'Nuestra Historia',
        href: '/es/about',
      },
      {
        type: 'our-team',
        title: 'Nuestro Equipo',
        href: '/es/acerca-de/nuestro-equipo',
      },
      {
        type: 'donate',
        title: 'Donar a Idealist',
        href: '/es/dona',
      },
    ],
  },
  contactUs: {
    title: 'Contactar',
    links: [
      {
        type: 'help-center',
        title: 'Ayuda',
        href: '/es/ayuda',
      },
      {
        type: 'contact-us',
        title: 'Contactar a Idealist',
        href: '/es/about/contactanos',
      },
      {
        type: 'terms-of-service',
        title: 'Términos de Servicio',
        href: '/en/terms-of-service',
      },
      {
        type: 'privacy-policy',
        title: 'Política de Privacidad',
        href: '/en/privacy-policy',
      },
      {
        type: 'site-map',
        title: 'Mapa del Sitio',
        href: '/es/mapasitio',
      },
    ],
  },
  missionStatement:
    'Trabajando con otros, con un espíritu de generosidad y respeto mutuo, queremos ayudar a construir un mundo en el que todas las personas puedan vivir libre y dignamente.',
};
